import React from "react";
import {BrowserRouter,Route,Routes} from "react-router-dom"
import Register from "./AuthUser/Register"
import Login from "./AuthUser/Logins"
import Home from "./pages/Home"
import { UserAuthProvider } from "./context/authuser";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/loadhelper.css"
import Chat from "./pages/Chat";
import ProfileInfo from "./pages/ProfileInfo";
import MobileInfo from "./pages/mobileProfile";

export default function Main(){
  return(
    <div>
        <BrowserRouter>
          <UserAuthProvider>
           <Routes>
               <Route path="/" element={<Register/>}/>
               <Route path="/login" element={<Login/>}/>
               <Route path="/home" element={<Home/>}/>
               <Route  path="/chat"  element={<Chat/>}/>
               <Route path="/profile" element={<ProfileInfo/>}/>
               <Route path="/mobile/:id" element={<MobileInfo/>}/>

               
          </Routes>
          </UserAuthProvider>
          <ToastContainer autoClose={3000} hideProgressBar={true}/>

        </BrowserRouter>
    </div>
  )
}

